import { isReactNative } from 'yofobasement/utils/runtime';
let AppState = {
  addEventListener: () => {},
  removeEventListener: () => {}
};

if (isReactNative()) {
  try {
    const rn = require('react-native');
    if (rn) {
      AppState = rn.AppState;
    }
  } catch (error) {}
}

export default AppState;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/AppState.js